import { LinkSvg } from '../../../Components/icons';

export const openLinkInNewTab = (link) => {
  window.open(link, '_blank');
};

export const links = [
  {
    name: 'Farmbiosecurity',
    link: 'https://www.farmbiosecurity.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture - Federal',
    link: 'https://www.agriculture.gov.au/agriculture-land',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – Victoria',
    link: 'https://agriculture.vic.gov.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – NSW',
    link: 'https://www.dpi.nsw.gov.au/agriculture',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – PIRSA',
    link: 'https://pir.sa.gov.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – QLD',
    link: 'https://www.daf.qld.gov.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – Tasmania',
    link: 'https://nre.tas.gov.au/agriculture',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – WA',
    link: 'https://www.agric.wa.gov.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Department of Agriculture – NT',
    link: 'https://industry.nt.gov.au/industries/primary-industry/agriculture',
    icon: <LinkSvg />,
  },
  {
    name: 'National Farmers Federation',
    link: 'https://nff.org.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Meat Livestock Australia',
    link: 'https://www.mla.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Plant Health Australia',
    link: 'https://www.planthealthaustralia.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Animal Health Australia',
    link: 'https://animalhealthaustralia.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Horticulture Innovation',
    link: 'https://www.horticulture.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Dairy Australia',
    link: 'https://www.dairy.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Pork Australia',
    link: 'https://www.pork.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Real Estate Australia',
    link: 'https://www.realestate.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'WXMaps',
    link: 'http://www.wxmaps.org/fcst.php',
    icon: <LinkSvg />,
  },
  {
    name: 'Bureau of Meteorology',
    link: 'http://www.bom.gov.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Elders',
    link: 'https://elders.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Nutrien Ag Solutions',
    link: 'https://www.nutrienagsolutions.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Heart of a Nation',
    link: 'https://www.heartofthenation.com.au/',
    icon: <LinkSvg />,
  },
  {
    name: 'Your local Hospital',
    link: 'https://www.barwonhealth.org.au/',
    icon: <LinkSvg />,
  },
];
